import { isFailure, ThreatsData } from "@sportal/api";
import {
  Notificator,
  NotificationActionTypes,
} from "../../components/notification";
import { SBThunkAction } from "../redux.types";
import {
  FETCH_THREATS,
  FETCH_THREATS_FAILURE,
  FETCH_THREATS_SUCCESS,
  ThreatsActionTypes,
} from "./threats.types";
import { shouldLoad } from "../shared";

export const fetchThreats =
  (): SBThunkAction<void, ThreatsActionTypes | NotificationActionTypes> =>
  async (dispatch, getState, { api }) => {
    const { accountSettings, threats } = getState();

    if (!shouldLoad(threats)) return;

    dispatch({ type: FETCH_THREATS });

    const result = await api.ssm.threats.get(accountSettings.language);

    if (isFailure(result)) {
      dispatch(fetchThreatsFailure(result.error));
      dispatch(Notificator.error("failed_to_load_threats"));
      return;
    }

    dispatch(fetchThreatsSuccess(result.data));
  };

export const fetchThreatsSuccess = (
  threats: ThreatsData
): ThreatsActionTypes => ({
  type: FETCH_THREATS_SUCCESS,
  payload: threats,
});

const fetchThreatsFailure = (error) => (dispatch) => {
  dispatch({ type: FETCH_THREATS_FAILURE, payload: error });
};
